import {Injectable} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {AppUpdateDialogComponent, ErrorDialogComponent} from '@shared/components';

@Injectable({
  providedIn: 'root'
})
export class ErrorDialogService {
  private modal: HTMLIonModalElement;

  constructor(
    private modalCtrl: ModalController,
  ) {
  }
  async showErrorModal(errorInfo: any) {
    this.modal = await this.modalCtrl.create({
      component: ErrorDialogComponent,
      componentProps: {
        errorInfo
      },
      cssClass: ['error-dialog-modal'],
      showBackdrop: true,
      backdropDismiss: true,
    });
    await this.modal.present();
  }
}
